import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  tr: {
    translation: {
      // Header
      nav: {
        home: "Ana Sayfa",
        products: "Ürünler",
        about: "Kurumsal",
        contact: "İletişim"
      },
      // Hero
      hero: {
        title: "Geleceğin Güvenliği",
        subtitle: "Savunma Sanayi ve Siber Güvenlikte Güvenilir Çözüm Ortağınız",
        cta: "Ürünlerimizi Keşfedin"
      },
      // Products
      products: {
        title: "Ürün ve Hizmetlerimiz",
        subtitle: "Savunma sanayi ve siber güvenlik alanında geniş ürün yelpazemizle hizmetinizdeyiz",
        items: {
          weapons: {
            title: "Silah ve Mühimmat",
            desc: "Her çap ve model ateşli yivli setli tabancalar, makineli tabancalar, keskin nişancı tüfekleri, yivli setli av tüfekleri, bomba atarlar, her çap ve model havanlar, hafif ve ağır toplar, obüsler ve bunların ana parçalarının tedariği"
          },
          armored: {
            title: "Zırhlı Araçlar",
            desc: "Tanklar, tırtıllı ve tekerlekli zırhlı muharebe araçları, zırhlı personel taşıyıcılar ile üzerinde askeri ekipman bulunan her türlü zırhlı personel taşıyıcılar, zırhlı silah/mühimmat taşıyıcı araçların tedariği"
          },
          explosives: {
            title: "Askeri Patlayıcılar",
            desc: "Askeri Patlayıcılar ve Piroteknik Malzeme Her türlü mühimmat ve bunlara ait ana parçalar ile sevk maddesi ve patlayıcıların tedariği"
          },
          missiles: {
            title: "Roket ve Füzeler",
            desc: "Her çap ve menzildeki roketler, füzeler ve torpidolar ile bu sistemlere ait ana parçaların tedariği"
          },
          cyber: {
            title: "Siber Güvenlik",
            desc: "İleri düzey siber güvenlik çözümleri, ağ güvenliği, veri koruma ve tehdit analizi sistemleri"
          }
        }
      },
      // About
      about: {
        title: "Biz Kimiz",
        subtitle: "Tarvex Defence Systems, Ankara Ticaret Odası'na kayıtlı bir Savunma Sanayi Şirketi olarak, Silah ve Mühimmat Ticareti ile Siber Güvenlik alanlarında faaliyet göstermektedir. 2025 yılında Ankara'da kurulan şirketimiz savunma sanayi alanında her türlü harp araç ve gereçlerinin tedariği konusunda farklı çözümler sunmaktadır.",
        mission: {
          title: "Misyonumuz",
          desc: "Müşterilerimizin her türlü harp araç ve gereçlerini elde etmelerini sağlayarak sahada daha uzun vadede kalmalarını sağlamak. Ayrıca akıllı siber güvenlik çözümleri sunmaktır."
        },
        vision: {
          title: "Vizyonumuz",
          desc: "Savunma sanayi ürünlerinin her geçen gün geliştiği göz önüne alınarak gelişmeleri takip etmek ve farklı harekât ihtiyaçlarına hitap edebilecek ürünleri tespit etmek ve tedariğini sağlamaktır."
        },
        values: {
          title: "Temel Değerlerimiz",
          items: [
            "Dürüstlük – Şeffaflık ve etik sorumlulukla hareket ederiz.",
            "Yenilikçilik – Daha akıllı, daha hızlı ve daha güvenli çözümler geliştiririz.",
            "Gizlilik – Müşteri verilerini en yüksek öncelikle koruruz.",
            "Mükemmeliyet – Sunulan her çözümde kusursuzluğu hedefleriz.",
            "Dayanıklılık – Kurumları geleceğin siber tehditlerine karşı hazırlarız."
          ]
        }
      },
      // Contact
      contact: {
        title: "İletişim",
        subtitle: "Projeleriniz için bizimle iletişime geçin. Size en uygun çözümleri sunmaya hazırız.",
        phone: "Telefon",
        email: "E-posta",
        address: "Adres",
        addressText: "Çukurambar Mah. 1424 Cad. No: 6/1 İç Kapı No: 171, Çankaya/Ankara"
      },
      // Footer
      footer: {
        description: "Savunma sanayi ve siber güvenlik alanında güvenilir çözüm ortağınız. Her türlü harp araç ve gereçlerinin tedariği ve akıllı siber güvenlik çözümleri.",
        corporate: "Kurumsal",
        aboutUs: "Hakkımızda",
        ourProducts: "Ürünlerimiz",
        privacy: "Gizlilik Politikası",
        terms: "Kullanım Koşulları",
        rights: "Tüm hakları saklıdır."
      }
    }
  },
  en: {
    translation: {
      // Header
      nav: {
        home: "Home",
        products: "Products",
        about: "About",
        contact: "Contact"
      },
      // Hero
      hero: {
        title: "Security of the Future",
        subtitle: "Your Trusted Partner in Defense Industry and Cyber Security",
        cta: "Explore Our Products"
      },
      // Products
      products: {
        title: "Our Products and Services",
        subtitle: "We serve you with our wide range of products in defense industry and cyber security",
        items: {
          weapons: {
            title: "Weapons and Ammunition",
            desc: "Supply of all caliber and model firearms, pistols, machine guns, sniper rifles, hunting rifles, grenade launchers, all caliber and model mortars, light and heavy artillery, howitzers and their main components"
          },
          armored: {
            title: "Armored Vehicles",
            desc: "Supply of tanks, tracked and wheeled armored combat vehicles, armored personnel carriers with military equipment, armored weapon/ammunition transport vehicles"
          },
          explosives: {
            title: "Military Explosives",
            desc: "Military Explosives and Pyrotechnic Materials Supply of all types of ammunition and their main components, propellants and explosives"
          },
          missiles: {
            title: "Rockets and Missiles",
            desc: "Supply of rockets, missiles and torpedoes of all calibers and ranges and their main components"
          },
          cyber: {
            title: "Cyber Security",
            desc: "Advanced cyber security solutions, network security, data protection and threat analysis systems"
          }
        }
      },
      // About
      about: {
        title: "Who We Are",
        subtitle: "Tarvex Defence Systems, as a Defense Industry Company registered with Ankara Chamber of Commerce, operates in the fields of Weapons and Ammunition Trade and Cyber Security. Our company, established in Ankara in 2025, offers different solutions for the supply of all kinds of military equipment in the defense industry.",
        mission: {
          title: "Our Mission",
          desc: "To enable our customers to obtain all kinds of military equipment and ensure they remain in the field for the long term. Also, to provide smart cyber security solutions."
        },
        vision: {
          title: "Our Vision",
          desc: "Considering that defense industry products are developing day by day, to follow the developments and identify products that can meet different operational needs and provide their supply."
        },
        values: {
          title: "Our Core Values",
          items: [
            "Integrity – We operate with transparency and ethical responsibility.",
            "Innovation – We develop smarter, faster, and safer solutions.",
            "Confidentiality – We protect our clients' data as our top priority.",
            "Excellence – We pursue perfection in every solution we offer.",
            "Resilience – We prepare organizations for the cybersecurity challenges of tomorrow."
          ]
        }
      },
      // Contact
      contact: {
        title: "Contact",
        subtitle: "Get in touch with us for your projects. We are ready to offer you the most suitable solutions.",
        phone: "Phone",
        email: "Email",
        address: "Address",
        addressText: "Çukurambar Mah. 1424 Cad. No: 6/1 İç Kapı No: 171, Çankaya/Ankara"
      },
      // Footer
      footer: {
        description: "Your trusted partner in defense industry and cyber security. Supply of all kinds of military equipment and smart cyber security solutions.",
        corporate: "Corporate",
        aboutUs: "About Us",
        ourProducts: "Our Products",
        privacy: "Privacy Policy",
        terms: "Terms of Use",
        rights: "All rights reserved."
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage']
    }
  });

export default i18n;